import { optCollection } from './BasicOperate';
import { dispatch, getState } from '@@/store';
import { ShowNormalDeal, ShowBrokeredDeal, ShowBreakContract } from '@/shared/utils';
export function winBiddingOperateColumn(props) {
    const { pageIdentification, record, orderCallback } = props;
    return optCollection({
        pageIdentification,
        record,
        // 撮合成交
        winningDealClick: () => {
            ShowBrokeredDeal({
                winningPrice: record.sellerPriceYuanUnit, commission: record.brokerageYuanUnit, servicePrice: record.commissionYuanUnit, handPrice: record.totalPriceYuanUnit, showTransferWay: Number(record.transferMode) === 0 ? false : true, orderId: record.orderId, callback: () => {
                    if (orderCallback) {
                        orderCallback();
                    }
                    else {
                        opt.commonUpdateTable();
                    }
                },
            });
        },
        // 正常成交
        normalDealClick: () => {
            ShowNormalDeal({
                sellerPriceYuanUnit: record.sellerPriceYuanUnit, transferMode: Number(record.transferMode) === 0 ? false : true, orderId: record.orderId, callback: () => {
                    if (orderCallback) {
                        orderCallback();
                    }
                    else {
                        opt.commonUpdateTable();
                    }
                }
            });
        },
        // 违约
        breakContractClick: () => {
            ShowBreakContract({
                orderId: record.orderId, callback: () => {
                    if (orderCallback) {
                        orderCallback();
                    }
                    else {
                        opt.commonUpdateTable();
                    }
                }
            });
            dispatch.breakContract.defaultType();
            dispatch.breakContract.defaultOriginator();
        },
        // 详情
        bidDetailsCilck: () => {
            dispatch.router.push({
                path: '/carManage/offerdetails',
                query: {
                    id: record.auctionId,
                },
            });
        },
    });
}
const opt = {
    updateTable(index) {
        dispatch.winBiddingCar.updateTable(index);
        dispatch.winBiddingCar.getOrderCountInfoApi({});
    },
    commonUpdateTable() {
        const { pageCurrent, tableData } = getState().winBiddingCar;
        const tableDataLength = tableData.length - 1;
        if (pageCurrent !== 1) {
            if (tableDataLength === 0) {
                this.updateTable(pageCurrent - 1);
            }
            else {
                this.updateTable(pageCurrent);
            }
        }
        else {
            this.updateTable(pageCurrent);
        }
    },
};
